import { Button } from "@mui/material"
import SimpleLabel from "../components/Label";
import { red } from "@mui/material/colors";
import { TRowItem } from "../components/Table/TableRow";
import { ClientResponse } from "../config/types";
import { actionDialogStore, alertDialogStore } from "../store/dialogs";


interface BulkDeleteControllerProps{
    selectedRowItems:TRowItem[],
    reset:()=>void
    ftn:(_id:string)=> Promise<ClientResponse<any>>
    idKey?:string
}

export const BulkDeleteController=({selectedRowItems,ftn,idKey,reset}:BulkDeleteControllerProps)=>{
        const batchDeleteAction = async () => {
          let result = { 
            success: 0, 
            failed: 0, 
            commonMsg: [""],
            hasError:false
           };
          await Promise.all(
            selectedRowItems.map(async (item) => {
              const res = await ftn(
                item[idKey??'id']
              );
              if (res.success) {
                result.success += 1;
              } else {
                result.failed += 1;
                result.commonMsg.push(res.message);
                result.hasError=true
              }
            })
          );
          reset()
          alertDialogStore.open({
            title: "Batch Delete",
            subtitle: `[${result.success}] deleted successfully, 
            [${result.failed}] failed. ${result.hasError ? result.commonMsg:'' }`,
            isSuccess: true,
          });

        };
        const toggleBatchDelete = () => {
          actionDialogStore.open({
            title: "Batch Delete Record",
            subtitle: `${selectedRowItems.length} selected,
                        , ONLY admin can restore. Are you sure you want to proceed?`,
            onRightBtnPress: batchDeleteAction,
            rightBtnTxt: "Confirm",
            onLeftBtnPress: () => {},
          });
        };
    

    return<>
         {selectedRowItems.length !== 0 && (
          <Button
            onClick={toggleBatchDelete}
            variant="text"
            sx={styles.dialogItemBtn}
          >
            <SimpleLabel
              title={`Delete ${selectedRowItems.length}`}
              color={red[700]}
              fontSize={13}
            />
          </Button>
        )}</>
}

const styles = {
    dialogItemBtn: {
      textTransform: "none",
      width: "100%",
      padding: 1,
      alignText: "left",
    },
  };